module.exports = __webpack_public_path__ + "img/AddUser.9c73e34b.svg";